/*
공용 Util 또는 Enum
모든 html 에 포함되는 내용을 담아요.
*/

// ENUM ------------------

const USER_STATE = {
  joined: 1,
  deleted: 2,
  
  label: function (m) {
    switch (m) {
      case 1: return "가입";
      case 2: return "탈퇴";
      default:
        return m;
    }
  }
};

const CLASS_STATE = {
  invisible: 0,
  live: 1,
  wait: 2,
  closed: 3,
  suspend: 4,
  link: 5,
  
  label: function (m) {
    switch (m) {
      case 0: return "비공개";
      case 1: return "라이브";
      case 2: return "준비중(심사대기)";
      case 3: return "종료됨";
      case 4: return "심사보류";
      case 5: return "링크접속";
      default:
        return m;
    }
  }
};

const EXTRA_COACH_ROLE = {
  log: "log",
  diet: "diet",
  homework: "homework",
  
  label:function (m) {
    switch (m) {
      case 'log': return "운동";
      case 'diet': return "식단";
      case 'homework': return "과제";
      default:
        return m;
    }
  },
  values: function () {
    return ['log', 'diet', 'homework'];
  }
};

const MISSION_TYPE = {
  log: "log",
  diet: "diet",
  homework: "homework",
  
  label:function (m) {
    switch (m) {
      case 'log': return "운동";
      case 'diet': return "식단";
      case 'homework': return "과제";
      default:
        return m;
    }
  },
  values: function () {
    return ['log', 'diet', 'homework'];
  },
  /**
   * missionScore[].item 의 포인트 계산
   * @param item missionScore 배열의 아이템
   * @param type 특정 타입만 선택
   * @returns {*|number|number}
   */
  calcItemPoint: function (item, type = '') {
    if (item) {
      return MISSION_TYPE.values()
        .filter((el) => type ? el == type : true)
        .reduce((pre, key) => pre + parseInt(item[key] ? item[key] : 0, 10), 0);
    }
    return 0;
  },
  /**
   * userClass 의 missionScore 모델에서 합계 구함.
   * @param score
   * @param type 특정 타입만 선택
   * @returns {number|*}
   */
  calcSum: function (score, type = '') {
    if (score && score.length > 0) {
      return score.reduce(function (add, it) {
        return add + MISSION_TYPE.values()
          .filter((el) => type ? el == type : true)
          .reduce((pre, key) => pre + parseInt(it[key] ? it[key] : 0, 10), 0);
      }, 0);
    }
    return 0;
  }
}

/**
 * 식사 종류
 * @type {{lunch: string, snack: string, breakfast: string, dinner: string}}
 */
const DIET_MEAL = {
  breakfast: 'breakfast',
  lunch: 'lunch',
  dinner: 'dinner',
  snack: 'snack',
  
  values: function () {
    return ['breakfast', 'lunch', 'dinner', 'snack'];
  },
  label:function (meal) {
    switch (meal) {
      case this.breakfast: return '아침';
      case this.lunch: return '점심';
      case this.dinner: return '저녁';
      case this.snack: return '간식';
      default:
        return meal;
    }
  }
}

/**
 * UserClass 운동 진행 상태
 */
const USER_CLASS_STATE = {
  ready: 'ready',
  ing: 'ing',
  end: 'end',
  canceled: 'canceled',
  
  label:function (state) {
    switch (state) {
      case this.ready: return '대기중';
      case this.ing: return '진행중';
      case this.end: return '종료됨';
      case this.canceled: return '취소됨';
      default:
        return state;
    }
  },
  
  isLive: function (state) {
    return state == this.ready || state == this.ing;
  }
};


// region - EXTENSIONS ------------------

/**
 * 이미지 사이즈 쿼리
 * @param {number} w Width
 * @param {number?} h Height
 * @param {number} q Quality
 * @returns {String|string}
 */
String.prototype.imageSizeQuery = function (w = 1024, h = undefined, q = 85) {
  return CommonUtil.imageSizeQuery(this, w, h, q);
}

String.prototype.isBlank = function() {
  return this.trim().length === 0;
};

String.prototype.format = function () {
  let i = 0, args = arguments;
  return this.replace(/{}/g, function () {
    return typeof args[i] != 'undefined' ? args[i++] : '';
  });
};
/**
 * 10 자리, 13자리에 따라 다르게 local 로 변환
 * @param moment
 * @returns {moment.Moment}
 */
Number.prototype.resolveUtc = function (moment) {
  let time = this + "";
  if (time.length > 10) {
    return moment(this).local();
  }
  return moment.unix(time).local();
}

String.prototype.hasOnlyNumbers = function () {
  return /^\d+$/.test(this);
}

String.prototype.resolveUtc = function (moment) {
  if (this.hasOnlyNumbers) {
    let time = parseInt(this, 10);
    if (time) {
      return time.resolveUtc(moment);
    }
  }
  return moment.utc(this).local();
}

// endregion



const CommonUtil = {
  
  /**
   * 오브젝트 복제
   * @param o
   * @returns {any}
   */
  cloneDeep(o) {
    return JSON.parse(JSON.stringify(o));
  },
  
  /**
   * 오브젝트 간단 복제 (primitive 속성만)
   * @param {object} o
   * @returns {*}
   */
  cloneShallow(o) {
    return Object.assign({}, o);
  },
  
  /**
   * 메일 형식 체크
   * @param {string} email
   * @returns {boolean}
   */
  isMail: function (email) {
    if (email) {
      const pattern = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      return pattern.test(email);
    }
    return false;
  },
  /**
   * 이미지 주소인지 확장자로 판단
   * @param {string} path
   * @returns {boolean}
   */
  isImageUrl: function(path) {
    if (path && typeof path === 'string') {
      let extensions = ['png', 'tiff', 'tif', 'jpg', 'jpeg', 'gif', 'bmp', 'ico', 'cur', 'xbm'];
      let end3 = path.substring(path.length - 3).toLowerCase();
      let end4 = path.substring(path.length - 3).toLowerCase();
      if (extensions.find(it => it == end3 || it == end4)) return true;
    }
    return false;
  },
  
  faceImageQuery: function (urlString, w = 96, h = undefined, q = 85) {
    if (urlString && typeof urlString === 'string' && urlString.startsWith('http')) {
      return this.imageSizeQuery(urlString, w, h, q);
    }
    return "/img/profile_default@3x.jpg";
  },
  
  /**
   * 이미지 사이즈 쿼리
   * @param {string} urlString
   * @param {number} w Width
   * @param {number?} h Height
   * @param {number} q Quality
   * @returns {String|string}
   */
  imageSizeQuery: function (urlString, w = 1024, h = undefined, q = 85) {
    if (urlString && typeof urlString === 'string' && urlString.startsWith('http')) {
      if(urlString.trim().length == 0 || urlString.indexOf('?w=') > 0) return urlString;
      let query = `${urlString}?w=${w}&q=${q}`;
      if (h) {
        query += `&h=${h}`;
      }
      return query;
    }
    return urlString;
  },
  /**
   * 데이터 URI를 Blob로 변경
   * @param dataURI
   * @returns {Blob}
   */
  dataURItoBlob: function(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type:mimeString});
  },
  
  /**
   * 에러 메시지 추출
   * @param error
   * @returns {string|*}
   */
  getErrorMessage(error) {
    if (error) {
      if (error.responseJSON) {
        // kakao auth error
        return error.responseJSON.error_description;
      }
      if (error.message) {
        return error.message;
      }
    }
    return '';
  },
  
  /**
   * 널이 아니면 value 를 함수에 전달.
   * @param value
   * @param fn
   */
  runIfNotNull: function(value, fn) {
    if (value !== undefined && value !== null) {
      if (typeof value === 'string') {
        if (value) fn(value);
      } else {
        fn(value);
      }
    }
  },
  
  /**
   * 딜레이 후 실행
   * @param {number} ms milliseconds in delayed run
   * @param {*} data argument in delayed run
   * @returns {Promise<unknown>}
   */
  delayRun: function (ms, data = undefined) {
    return new Promise(resolve => setTimeout(resolve, ms, data));
  },
  
  /**
   * 문자 또는 특수문자 제거
   * @param {string} text
   * @returns {*}
   */
  removeAllNotNumbers: function (text) {
    try {
      return text.replaceAll(/[^0-9]/g, '');
    } catch (e) {
      return text;
    }
  },
  /**
   * 01012341234 를 010-1234-1234 형식으로 변경
   * @param text
   * @param delimiter
   */
  formatPhoneNumber: function (text, delimiter = '-') {
    if (!this.checkIsPhoneNumber(text)) return text;
    return text.substring(0, 3) + delimiter + text.substring(3, 7) + delimiter + text.substring(7);
  },
  
  /**
   * 전화번호 체크
   * @param text
   * @returns {boolean}
   */
  checkIsPhoneNumber: function (text) {
    if (!text) return false;
    let reg = /^[0-9]{3}[0-9]{4}[0-9]{4}$/;
    return text.match(reg) != null;
  },
  /**
   * 하이픈을 포함하는 전화번호 체크
   * @param text
   * @returns {boolean}
   */
  checkIsPhoneNumberWithHyphen: function (text) {
    if (!text) return false;
    let reg = /^[0-9]{3}-+[0-9]{4}-+[0-9]{4}$/;
    return text.match(reg) != null;
  }
};


const ExcelUtil = {
  
  
  /**
   * 엑셀파일로 다운로드
   * @param {string} titleName 파일명
   * @param {string} sheetName 시트명
   * @param {array} dataArray 키-밸류 오브젝트 배열
   * @param {Object} columns 컬럼정보, dataArray 의 key 에 해당하는 헤더명을 배치
   *
   * @see https://docs.sheetjs.com/docs/getting-started/example
   */
  downloadAsExcel: function (titleName, dataArray = [], columns = {}, sheetName = 'Sheet 1') {
    if (!XLSX) {
      alert('xlsx.full.min.js 파일을 찾을 수 없습니다.');
      return;
    }
    if (!titleName) {
      alert('파일명이 필요합니다.');
      return;
    }
    // 컬럼데이터 없는 필드 제거
    const columnKeyList = Object.keys(columns);
    dataArray.map((el) => {
      for (let key in el) {
        if (columnKeyList.indexOf(key) < 0) {
          delete el[key];
        }
      }
    });
    
    const columnCodeArray = [];
    const columnNameArray = [];
    for (const key in columns) {
      columnCodeArray.push(key);
      columnNameArray.push(columns[key]);
    }
    
    const arrJSON = JSON.parse(JSON.stringify(dataArray));
    
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(worksheet, [columnNameArray]);
    XLSX.utils.sheet_add_json(worksheet, arrJSON, {origin: 'A2', skipHeader: true, header: columnCodeArray});
    
    //엑셀파일정보
    workbook.Props = {
      Title: titleName,
      Subject: "Excel",
      Author: "KeepFit",
      CreatedDate: new Date()
    };
    //엑셀 첫번째 시트네임
    workbook.SheetNames.push(sheetName);
    
    //시트에 데이터를 연결
    workbook.Sheets[sheetName] = worksheet;
    
    XLSX.writeFile(workbook, titleName + '.xlsx', { compression: true });
  }
};


const ImageUtil = {
  _resize: function(dataUrl, filename, compRatio, minWidth, minHeight, resultFunc) {
    const img = new Image();
    img.onload = function () {
      let width = minWidth || 0;
      let height = minHeight || 0;
      
      if (this.width > this.height) {
        width = Math.max(width, this.width * compRatio);
        height = width / this.width * this.height;
      } else {
        height = Math.max(height, this.height * compRatio);
        width = height / this.height * this.width;
      }
      
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);
      
      const dataURL = canvas.toDataURL('image/jpeg');
      const bytes = atob(dataURL.split(',')[1]);
      const mime = dataURL.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(bytes.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      
      var resizedFile = new Blob([ab], { type: mime });
      resizedFile.name = filename;
      resizedFile.filename = filename;
      
      resultFunc(resizedFile);
    };
    
    img.onerror = function () {
      resultFunc(-1);
    };
    img.src = dataUrl;
  },
  
  resizeImageFile: function(file, compRatio, minWidth, minHeight, resultFunc) {
    const reader = new FileReader();
    reader.onload = function (e) {
      ImageUtil._resize(e.target.result, file.name, compRatio, minWidth, minHeight, resultFunc);
    };
    reader.readAsDataURL(file);
  }
};


// region - HELPER ------------------

/**
 * HTML 사이드에서 개발 상태를 확인하도록 처리
 * @type {boolean}
 */
var DevDebugMode = false;

const devLog = function (data) {
  if (DevDebugMode) {
    console.log("kf::", data);
  }
}

/// 쿠키 키값 정리.
const CookieKey = {
  /**
   * 로그인 호출 레퍼러 주소
   */
  LoginReferer: 'loginReferrer',
  /**
   * 네이버 광고 로그 - 회원 가입 완료 페이지를 처리하기 위해 사용.
   */
  NaverWcsSignup: "wcs_signup",
};

/// datatable 콤포넌트의 커스텀 설정
const datatables_lang_kor = {
  'decimal': '',
  'emptyTable': '데이터가 없습니다.',
  'info': '_START_ - _END_ (총 _TOTAL_)',
  'infoEmpty': '0명',
  'infoFiltered': '(전체 _MAX_ 명 중 검색결과)',
  'infoPostFix': '',
  'thousands': ',',
  'lengthMenu': '_MENU_ 개씩 보기',
  'loadingRecords': '로딩중...',
  // 'processing': '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span>',
  'search': '검색 : ',
  'zeroRecords': '검색된 데이터가 없습니다.',
  'paginate': {
    'first': '첫 페이지',
    'last': '마지막 페이지',
    'next': '다음',
    'previous': '이전'
  },
  'aria': {
    'sortAscending': ' :  오름차순 정렬',
    'sortDescending': ' :  내림차순 정렬'
  }
};

/**
 * #wrapLoading 전체 로딩 표시
 */
function showFullLoading(withDimming = true) {
  let el = document.getElementById('wrapLoading');
  if (el) {
    el.classList.remove('d-none');
    if (!withDimming) {
      el.classList.add('noDimming');
    } else {
      el.classList.remove('noDimming');
    }
  }
}

/**
 * #wrapLoading 전체 로딩 숨기기
 */
function hideFullLoading() {
  let el = document.getElementById('wrapLoading');
  if (el) {
    el.classList.add('d-none');
  }
}

/**
 * 전체 로딩 표시
 * @param $target
 * @param message
 * @deprecated blockui.js 와 혼동되니 showFullLoading() 를 대신 사용하길 원합니다.
 */
function blockUI($target, message) {
  $('#wrapLoading').removeClass('d-none');
}

/**
 * 전체 로딩 숨기기
 * @param $target
 * @deprecated blockui.js 와 혼동되니 hideFullLoading() 를 대신 사용하길 원합니다.
 */
function unblockUI($target) {
  $('#wrapLoading').addClass('d-none');
}

function timeDifference(previous) {
  var current = Date.now();

  var msPerMinute = 60 * 1000;
  var msPerHour = msPerMinute * 60;
  var msPerDay = msPerHour * 24;
  var msPerMonth = msPerDay * 30;
  var msPerYear = msPerDay * 365;

  var elapsed = current - previous;

  if (elapsed < msPerMinute) {
    return Math.round(elapsed / 1000) + '초 전';
  } else if (elapsed < msPerHour) {
    return Math.round(elapsed / msPerMinute) + '분 전';
  } else if (elapsed < msPerDay) {
    return Math.round(elapsed / msPerHour) + '시간 전';
  } else if (elapsed < msPerMonth) {
    return Math.round(elapsed / msPerDay) + '일 전';
  } else if (elapsed < msPerYear) {
    return Math.round(elapsed / msPerMonth) + '달 전';
  } else {
    return Math.round(elapsed / msPerYear) + '년 전';
  }
}

function getDatetimeString(millis) {
  var date = new Date(millis);
  return date.getFullYear() + '.' + pad((date.getMonth() + 1), 2) + '.' + pad(date.getDate(), 2) + ' ' + pad(date.getHours(), 2) + ':' + pad(date.getMinutes(), 2);
}


function getDateString(millis) {
  var date = new Date(millis);
  return date.getFullYear() + '.' + pad((date.getMonth() + 1), 2) + '.' + pad(date.getDate(), 2);
}

/**
 * 숫자를 3자리씩 나눠줌.
 * @param n
 * @returns {*}
 */
function commify(n) {
  var reg = /(^[+-]?\d+)(\d{3})/;   // 정규식
  n += '';                          // 숫자를 문자열로 변환
  while (reg.test(n)) {
    n = n.replace(reg, '$1' + ',' + '$2');
  }
  return n;
}

/**
 * length 만큼 숫자를 문자로 변경
 * @param {number} number
 * @param {number} length
 * @returns {string}
 */
function pad(number, length = 0) {
  let str = number.toString();
  while (str.length < length) {
    str = '0' + str;
  }
  return str;
}

function comma(str) {
  str = String(str);
  return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
}

function uncomma(str) {
  str = String(str);
  return str.replace(/[^\d]+/g, '');
}

/**
 * 로그인 체크
 * @returns {boolean} 토큰 여부
 *
 * TODO service 로 이동
 */
function isLoggedIn() {
  return (!!getToken()) && getToken() !== 'undefined' && getToken() !== 'null';
}


function setCookie(key, value) {
  if (key === 'loginReferrer') {
    value = value.replace('login', '');
    value = value.replace('signup_pre', '');
  }
  $.cookie(key, value, { path: '/' });
  
  return "set " + key
}


function getCookie(key) {
  return $.cookie(key);
}


function removeCookie(key) {
  $.removeCookie(key, { path: '/' });
  return "rm " + key
}

/**
 * 에드핏 토큰 저장
 * @param token
 *
 * TODO service 로 이동
 */
function setToken(token) {
  if (token) {
    setCookie('token', token);
  } else {
    removeCookie('token');
  }
}

// TODO service 로 이동
function getToken() {
  return $.cookie('token');
}


function throwError(message, obj) {
  var e = new Error(message);
  e.userObj = obj;
  throw e;
}



/**
 * input jquery 오브젝트 옆 p 태그에 메시지 표시
 * @param $input
 * @param message
 */
function showErrorMessage($input, message) {
  $input.siblings('p').text(message || ' ');
  if (message) {
    $input.addClass('border-danger');
  } else {
    $input.removeClass('border-danger');
  }
}


function startTimer(count, display) {
  let minutes, seconds;
  timer = setInterval(function () {
    minutes = parseInt(count / 60, 10);
    seconds = parseInt(count % 60, 10);
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    display.html(minutes + ":" + seconds);
    // 타이머 끝
    if (--count < 0) {
      clearInterval(timer);
      // alert("시간초과");
      display.html("시간초과");
      $('#input-salt').data('salt', '');
      $('#btn-send-salt').attr("disabled", false).text('인증번호 재전송').addClass('btn-outline-info');
      isRunning = false;
    }
  }, 1000);
  isRunning = true;
}


// for imgCropper.njk
function cropDoneWithUrl(target, url) {
  setTimeout(function () {
    console.log(target, url);
    $('#' + target).prop('src', url);
  }, 500);
}

// for imgCropper.njk
function cropDoneWithBlob(target, blob) {
  var reader = new FileReader();
  reader.onload = function (e) {
    $('#' + target).prop('src', e.target.result);
  };
  reader.readAsDataURL(blob);
  $('#' + target).data('blob', blob);
}

// endregion

try {
  module.exports = {
    CommonUtil, commify, MISSION_TYPE, CLASS_STATE,
    USER_STATE, USER_CLASS_STATE, DIET_MEAL
  }
} catch (e) {
}